import { lazy } from 'react';

export const ModemPassword = lazy(() => import('./ModemPassword'));
export const SelfCarePassword = lazy(() => import('./SelfCarePassword'));
